import React from "react";
import { Text } from "react-native-paper";
import { FieldDisplayRendererProps } from "./types";
import { formatObjectValue } from "./formatObjectValue";

export const RatingDisplayRenderer = ({
  field,
  value,
}: FieldDisplayRendererProps) => {
  return <Text>{`${field.label}: ${formatObjectValue(value)} \u2B50`}</Text>;
};
